//
//
//
//
//
//

export default {
    props: {
        level: String,
        signature: String,
        is_mine: Boolean
    },
    methods: {
        goEdit() {
            if (this.is_mine) {
                wx.navigateTo({
                    url: '/personal_package/add_consultant/main?type=edit'
                })
            }
        }
    }
}
